import dateUtils from '../../../utils/dateUtils'
import replaceAll from '../../../utils/replaceAll'

/**
 * Used to find whether departure date is expired or not
 * @param {*} departureDate
 */
export default function isExpiredDate(departureDate) {
	const date = new Date()
	departureDate = departureDate
		? replaceAll(departureDate, '/', '-')
		: departureDate
	if (departureDate === null) return false
	departureDate = new Date(departureDate)
	return !(dateUtils().getGlobalDate(departureDate) > date)
}
